import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { HospitalRequest } from '../../../Data/Hospital';
import { dictionary } from '../../../dictionary';
import { NotificationType } from '../../../redux/initialState';
import { addNotification } from '../../../redux/notifications/notificationsActionCreator';
import { hospitalService } from '../../../Services/HospitalService';
import { FormFlow, FormFlowStepComponent } from '../../../Shared/FormFlow/FormFlow';
import { routes } from '../../../Utils/routes';
import { HospitalForm } from '../shared/HospitalForm';

const HospitalFormWrapper: FC<FormFlowStepComponent<HospitalRequest>> = ({ FormActionsComponent, onFormStepComplete }) =>
  <HospitalForm FormActionsComponent={FormActionsComponent} onFormStepComplete={onFormStepComplete} />;

export const CreateHospital: FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const onCancel = () => history.push(routes.hospitals.index);
  const onComplete = async (request: HospitalRequest) => {
    try {
      await hospitalService.create(request);
      dispatch(addNotification(NotificationType.success, dictionary.CREATE_HOSPITAL_SUCCESS));
      history.push(routes.hospitals.index);
    } catch (exception: any) {
      if (exception.message.includes('409')) {
        dispatch(addNotification(NotificationType.error, dictionary.HOSPITAL_NOT_UNIQUE_ERROR));
      } else {
        dispatch(addNotification(NotificationType.error, dictionary.CREATE_HOSPITAL_ERROR));
      }
    }
  };

  return (
    <FormFlow<HospitalRequest>
      onComplete={onComplete}
      onCancel={onCancel}
      completeButtonLabel={dictionary.CREATE_HOSPITAL_SUBMIT_BTN}
      steps={[
        { pageHeader: dictionary.CREATE_HOSPITAL_PAGE_HEADER, component: HospitalFormWrapper },
      ]}
    />
  );
};
